import * as angular from 'angular';
import { find } from 'lodash';
import { HelpDocsService, getAppName, getSupportEmail } from '@mode/shared/util-js';

interface DatabaseSelector {
  icon: string;
  link?: string;
  name: string;
  provider: string;
  vendor: string;
  view: string;
}

class SelectDbConnectController {
  readonly appName = getAppName();
  readonly intercomEmail = getSupportEmail();
  private dbList: DatabaseSelector[];
  private allDbList: DatabaseSelector[];
  private individualSelectorDbNames = [
    'Amazon Redshift',
    'Google BigQuery',
    'Microsoft SQL Server',
    'MySQL',
    'PostgreSQL',
    'Snowflake',
  ];
  private individualDbSelectorList: DatabaseSelector[];
  private username: string;
  private flowFromParams: string;

  static $inject = [];
  constructor(public helpDocs: HelpDocsService) {}

  $onInit() {
    this.allDbList = this.dbList.map((db) => {
      const datasourcePath =
        db.view === 'bridged'
          ? `/${this.username}/data_sources/bridges/default/${db.provider}/${db.vendor}`
          : `/${this.username}/data_sources/${db.provider}/${db.vendor}/new`;
      return { ...db, link: datasourcePath };
    });
    this.individualDbSelectorList = this.individualSelectorDbNames.map((name) => find(this.allDbList, { name }));
  }
}

const SelectDbConnectComponent: angular.IComponentOptions = {
  controller: SelectDbConnectController,
  controllerAs: 'ctrl',
  bindings: {
    dbList: '<',
    username: '<',
    flowFromParams: '<',
    showIntercomLink: '<',
  },
  template: `
  <div class="db-list">
    <div class="individual-db-selector">
      <selector-list
        db-list="ctrl.individualDbSelectorList"
        flow-from-params="ctrl.flowFromParams"
      ></selector-list>
    </div>
    <db-typeahead-selector
      db-list="ctrl.allDbList"
      flow-from-params="ctrl.flowFromParams"
    ></db-typeahead-selector>
    <div class="support-link">
      Don’t see your database?
      <a ng-if="ctrl.showIntercomLink"
        href
        intercom-show="Hi, I'd like to request support in {{ctrl.appName}} for the following database: "
        intercom-email="{{ctrl.intercomEmail}}"
        class="intercom-link new-db-request">
        Request support
      </a>
      <a ng-if="!ctrl.showIntercomLink"
        href="{{ ctrl.helpDocs.links['https://mode.com/help/articles/contact-us/'] }}"
        target="_blank"
        rel="noopener">
        Request support
      </a>
      for it.
    </div>
  </div>
  `,
};

export { SelectDbConnectComponent, DatabaseSelector };

angular.module('mode.components').component('selectDbConnect', SelectDbConnectComponent);
